var Org = require('org');


var OrgList = Backbone.Collection.extend({
    model: Org,
    initialize: function (models, options) {
        
    },
    comparator: function (message) {
        return message.get('creation_time');
    }
});


module.exports = OrgList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/orglist.js
// module id = N7yu
// module chunks = 1